import { useRuntimeConfig } from '#imports'
import type { RouteMeta, RouteRecordRaw } from 'vue-router'

import type { Market } from '@backmarket/http-api'

import redirectIfWebview from '../webviews/middleware/redirectIfWebview'

import { HELP_CENTER } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const { FF_ENABLED_INTERCOM_ROUTE_HELP_CENTER_BY_COUNTRY } =
    useRuntimeConfig().public

  const enableIntercom =
    FF_ENABLED_INTERCOM_ROUTE_HELP_CENTER_BY_COUNTRY?.includes(
      market.countryCode,
    )

  const commonRouteMeta: RouteMeta = {
    auth: {
      required: false,
    },
    userLoadingStrategy: 'server',
    // Required because help-center components are shown/hidden depending on auth state. it prevents UI flashes on full-page reload
    intercom: {
      enableIntercom,
      launcher: true,
      loading: 'onPageLoad',
    },

    owners: ['bot-squad-sales-customer-care-front'],
  }

  const helpCenterRoutes: RouteRecordRaw[] = [
    {
      name: HELP_CENTER.HOME,
      path: 'help',
      component: () => import('~/scopes/help-center/pages/Help.vue'),
      meta: {
        ...commonRouteMeta,
        layout: false,
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'webview',
      meta: { layout: 'webview-default' },
      children: [
        {
          name: HELP_CENTER.WEBVIEW.HOME,
          path: 'help',
          component: () => import('~/scopes/help-center/pages/HelpWebview.vue'),
          meta: {
            ...commonRouteMeta,
            shouldDisplayEdgeToEdge: false,
            isWebview: true,
          },
        },
      ],
    },
  ]

  return helpCenterRoutes
}
